import { useEffect, useRef, useState } from "react";
import { Polyline } from "react-leaflet";
import { Gauge, BatteryLow, Leaf } from "lucide-react";
import { WomaMap } from "./WomaMap";

// Livreur / chauffeur : suivi dynamique (la position vient du tracker adaptatif du tableau de bord)
export const CourierMapPanel = ({ user, position, status, onRequest, online, activeCourse, intervalMs, lowBattery }) => {
  const [trail, setTrail] = useState([]);
  const lastKey = useRef("");

  useEffect(() => {
    if (!position) return;
    const key = `${position.lat.toFixed(5)},${position.lng.toFixed(5)}`;
    if (key === lastKey.current) return;
    lastKey.current = key;
    setTrail((t) => [...t.slice(-59), [position.lat, position.lng]]);
  }, [position]);

  const role = user?.driver_type === "taxi" ? "taxi" : "courier";
  const ModeIcon = activeCourse ? Gauge : lowBattery ? BatteryLow : Leaf;
  const modeLabel = !online
    ? "Hors ligne · suivi en pause"
    : activeCourse
      ? "En course · position envoyée toutes les 5 s"
      : `Économie batterie · envoi toutes les ${Math.round(intervalMs / 1000)} s`;

  return (
    <section className="space-y-3" data-testid="courier-map-panel">
      <div className="flex items-center justify-between gap-3">
        <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#D4AF37]">Ma position en direct</p>
        <span className={`flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-full ${online ? "bg-emerald-500/15 text-emerald-300" : "bg-white/5 text-slate-400"}`} data-testid="courier-map-mode">
          <ModeIcon size={12} /> {modeLabel}
        </span>
      </div>
      <WomaMap self={position} role={role} status={status} onRequest={onRequest} follow={online} height={300} testId="courier-map">
        {trail.length > 1 && <Polyline positions={trail} pathOptions={{ color: "#22C55E", weight: 4, opacity: 0.7 }} />}
      </WomaMap>
    </section>
  );
};
